(() => {
  const storageKey = 'ceylera_preferences';
  const defaults = { tea: 0, spices: 0, cinnamon: 0, gifts: 0, visits: 0 };

  function readProfile() {
    try {
      return Object.assign({}, defaults, JSON.parse(localStorage.getItem(storageKey) || '{}'));
    } catch (error) {
      return Object.assign({}, defaults);
    }
  }

  function saveProfile(profile) {
    try { localStorage.setItem(storageKey, JSON.stringify(profile)); } catch (error) {}
  }

  function strongestInterest(profile) {
    return ['tea', 'cinnamon', 'spices', 'gifts'].sort((a, b) => profile[b] - profile[a])[0];
  }

  function personalize(profile) {
    const root = document.querySelector('[data-ceylera-personalized]');
    if (!root) return;
    const interest = strongestInterest(profile);
    if (!interest || profile[interest] < 2) return;

    root.setAttribute('data-persona', interest);
    document.querySelectorAll('[data-interest-card]').forEach((card) => {
      card.classList.toggle('is-personalized', card.getAttribute('data-interest-card') === interest);
    });
    document.querySelectorAll('[data-recommendation-panel]').forEach((panel) => {
      panel.hidden = panel.getAttribute('data-recommendation-panel') !== interest;
    });

    const heading = document.querySelector('[data-persona-heading]');
    const copy = document.querySelector('[data-persona-copy]');
    const link = document.querySelector('[data-persona-link]');
    if (heading && heading.getAttribute('data-' + interest)) heading.textContent = heading.getAttribute('data-' + interest);
    if (copy && copy.getAttribute('data-' + interest)) copy.textContent = copy.getAttribute('data-' + interest);
    if (link && link.getAttribute('data-' + interest)) link.setAttribute('href', link.getAttribute('data-' + interest));
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-interest]');
    if (!trigger) return;
    const interest = trigger.getAttribute('data-interest');
    const profile = readProfile();
    if (Object.prototype.hasOwnProperty.call(profile, interest)) {
      profile[interest] += 2;
      saveProfile(profile);
      personalize(profile);
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    const profile = readProfile();
    profile.visits += 1;
    saveProfile(profile);
    personalize(profile);

    document.querySelectorAll('[data-quiz-choice]').forEach((choice) => {
      choice.addEventListener('click', () => {
        const quiz = choice.closest('[data-ceylera-quiz]');
        if (!quiz) return;
        const current = choice.closest('[data-quiz-step]');
        const nextNumber = Number(current.getAttribute('data-quiz-step')) + 1;
        const interest = choice.getAttribute('data-interest');
        const updated = readProfile();
        if (interest && Object.prototype.hasOwnProperty.call(updated, interest)) updated[interest] += 3;
        saveProfile(updated);
        current.classList.remove('is-active');
        const next = quiz.querySelector('[data-quiz-step="' + nextNumber + '"]');
        if (next) next.classList.add('is-active');
        else {
          const result = quiz.querySelector('[data-quiz-result]');
          if (result) result.classList.add('is-active');
        }
      });
    });
  });
})();
